import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { I18nModule } from '@app/core';
import { ImvUiBoxLink, ImvUiJumbotron } from '@app/ui-kit';
import { HomeComponent } from './components/home/home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormControlModule } from 'src/app/shared/components';
import { FaqComponent } from './components/faq/faq.component';

@NgModule({
	declarations: [HomeComponent, ImvUiBoxLink, ImvUiJumbotron, FaqComponent],
	imports: [
		CommonModule,
		HomeRoutingModule,
		SharedModule,
		I18nModule.forFeature('home'),
		FormControlModule
	],
	exports: [HomeComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
